import { getCookie, setCookie } from 'cookies-next'
import { useEffect } from 'react'

export const useInitialReferrer = () => {
  useEffect(() => {
    const isClient = () => typeof window !== 'undefined' && window !== null

    if (!isClient()) return
    const initialReferrer = getCookie('initial_referrer')

    if (!initialReferrer) {
      setCookie('initial_referrer', document.referrer || '$direct', {
        maxAge: 60 * 60 * 24 * 365,
        path: '/',
      })
      const referringDomain = document.referrer
        ? new URL(document.referrer).host
        : '$direct'

      setCookie('initial_referring_domain', referringDomain, {
        maxAge: 60 * 60 * 24 * 365,
        path: '/',
      })
    }
  }, [])
}
